/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />
/// <reference path="../organization-settings/organization.settings.model.ts" />

module Eseebase {
    export class FloorplanCanvasModel {
        private elementId: string;
        private dragX: number;
        private dragY: number;
        private dragElement: HTMLElement;
        private canvasContext: CanvasRenderingContext2D;
        public unsubscribeEvents: Function;
        public correctionType: CorrectionType;
        constructor(id: string, public canEdit: boolean, canvasClick: Function, getZoom: Function, pushIcon: Function, public $timeout: ng.ITimeoutService) {
            this.elementId = id;

            var vm = this;
            function onIconMouseMove(e) {
                if (vm.dragElement != null) {
                    var clientX = e.touches ? e.touches[0].clientX : e.clientX;
                    var clientY = e.touches ? e.touches[0].clientY : e.clientY;
                    vm.dragElement.style.top = (clientY - vm.dragY) + 'px';
                    vm.dragElement.style.left = (clientX - vm.dragX) + 'px';
                }
            }
            function windowTouchMove(e) {
                e.preventDefault();
            }
            var parentOffset = $('#canvasContainer').offset();
            var line;
            var lineX, lineY;
            var cursorOffsetX = 0;
            var cursorOffsetY = 0;
            var verticalMargin = 0;
            var extraWidth = 0;
            var resizing = false;
            function onCanvasMouseDown(e) {
                if (e.target == null || $(e.target).attr('id') != 'canvasContainer') {
                    return;
                }
                canvasClick();
                if (vm.correctionType == null) {
                    return;
                }
                var evt = e.originalEvent == null ? e : e.originalEvent;
                
                parentOffset = $('#canvasContainer').offset();
                var pageX = evt.touches ? evt.touches[0].pageX : evt.pageX;
                var pageY = evt.touches ? evt.touches[0].pageY : evt.pageY;
                if (vm.correctionType.toString() == CorrectionType[CorrectionType.edit] ||
                    vm.correctionType.toString() == CorrectionType[CorrectionType.arrow]) {
                    evt.target.addEventListener('mousemove', onCanvasMouseMove, true);
                    if (evt.touches) {
                        evt.target.addEventListener('touchmove', onCanvasMouseMove, true);
                        (<any>window).addEventListener('touchmove', windowTouchMove, { passive: false });
                    }
                    if (vm.correctionType.toString() == CorrectionType[CorrectionType.edit]) {
                        verticalMargin = 7;
                    }
                    line = document.createElement('div');
                    line.style.width = '0px';
                    line.style.left = (pageX - parentOffset.left) + 'px';
                    line.className = vm.correctionType.toString() == CorrectionType[CorrectionType.edit] ? 'pen' : 'arrow';
                    extraWidth = vm.correctionType.toString() == CorrectionType[CorrectionType.edit] ? 0 : 10;
                    line.style.top = (pageY - parentOffset.top - verticalMargin) + 'px';
                    document.getElementById('canvasContainer').appendChild(line);
                    lineX = pageX;
                    lineY = pageY;
                }
                else if (vm.correctionType.toString() == CorrectionType[CorrectionType.comment]) {
                }
                else {
                    var item = new CorrectionItemViewModel();
                    item.correctionType = vm.correctionType;
                    item.locationX = (pageX - parentOffset.left) / getZoom();
                    item.locationY = (pageY - parentOffset.top) / getZoom();
                    pushIcon(item);
                    vm.resetDrawingTool();
                }
                
            }

            function onCanvasMouseMove(e) {
                if (line == null) {
                    return;
                }
                var evt = e.originalEvent == null ? e : e.originalEvent;
                var pageX = evt.touches ? evt.touches[0].pageX : evt.pageX;
                var pageY = evt.touches ? evt.touches[0].pageY : evt.pageY;
                cursorOffsetX = pageX - lineX;
                cursorOffsetY = pageY - lineY;
                var angle = getRotationAngle(cursorOffsetX, cursorOffsetY);
                var width = 0;
                if (angle % (Math.PI / 2) == 0) {
                    width = Math.max(Math.abs(cursorOffsetX), Math.abs(cursorOffsetY));
                }
                else {
                    var side = Math.min(Math.abs(cursorOffsetX), Math.abs(cursorOffsetY));
                    width = Math.sqrt(2 * Math.pow(side, 2));
                }
                width = width - extraWidth;
                if (angle < -(Math.PI / 2) && angle > -3 * (Math.PI / 2)) {
                    $(line).find('.title').addClass('flip');
                }
                else {
                    $(line).find('.title').removeClass('flip');
                }

                line.style.width = width + 'px';
                line.style.transform = 'rotate(' + angle + 'rad)';
            }

            function getRotationAngle(cursorOffsetX, cursorOffsetY) {
                var angle = 0;
                var quarter = 0;
                if (cursorOffsetX > 0 && cursorOffsetY < 0) {
                    angle = Math.atan(Math.abs(cursorOffsetY) / Math.abs(cursorOffsetX));
                } else if (cursorOffsetX < 0 && cursorOffsetY < 0) {
                    quarter = 1;
                    angle = Math.atan(Math.abs(cursorOffsetX) / Math.abs(cursorOffsetY));
                }
                else if (cursorOffsetX < 0 && cursorOffsetY > 0) {
                    angle = Math.atan(Math.abs(cursorOffsetY) / Math.abs(cursorOffsetX));
                    quarter = 2;
                }
                else if (cursorOffsetX > 0 && cursorOffsetY > 0) {
                    angle = Math.atan(Math.abs(cursorOffsetX) / Math.abs(cursorOffsetY));
                    quarter = 3;
                }
                if (angle < Math.PI / 6) {
                    angle = 0;
                }
                else if (angle > Math.PI / 6 && angle < Math.PI / 3) {
                    angle = Math.PI / 4;
                } else {
                    angle = Math.PI / 2;
                }
                return -1 * (angle + quarter * Math.PI / 2);
            }

            function onIconMouseDown(e) {
                if (resizing) {
                    return;
                }
                var evt = e.originalEvent == null ? e : e.originalEvent;
                vm.dragElement = $(evt.target).closest('.correction,.pen,.arrow')[0];
                var clientX = evt.touches ? evt.touches[0].clientX : evt.clientX;
                var clientY = evt.touches ? evt.touches[0].clientY : evt.clientY;
                vm.dragX = clientX - vm.dragElement.offsetLeft;
                vm.dragY = clientY - vm.dragElement.offsetTop;
                vm.dragElement.parentElement.addEventListener('mousemove', onIconMouseMove, true);
                if (evt.touches) {
                    vm.dragElement.parentElement.addEventListener('touchmove', onIconMouseMove, true);
                    (<any>window).addEventListener('touchmove', windowTouchMove, { passive: false });
                }
                $(vm.dragElement).addClass('dragging');
            }

            function mouseUp(e) {
                var evt = e.originalEvent == null ? e : e.originalEvent;
                if (vm.dragElement != null && vm.dragElement.parentElement != null) {
                    vm.dragElement.parentElement.removeEventListener('mousemove', onIconMouseMove, true);
                    if (evt.touches) {
                        vm.dragElement.parentElement.removeEventListener('touchmove', onIconMouseMove, true);
                    }
                    $(vm.dragElement).removeClass('dragging');
                    if ($(vm.dragElement).find('.icon').length > 0) {
                        $(vm.dragElement).find('.icon').addClass('touchend');
                        $(vm.dragElement).find('.icon')[0].click();
                    }
                    else {
                        $(vm.dragElement).addClass('touchend');
                        vm.dragElement.click();
                    }                    
                    vm.dragElement = null;
                }
                if (line != null) {
                    vm.getElement().removeEventListener('mousemove', onIconMouseMove, true);
                    if (evt.touches) {
                        vm.getElement().removeEventListener('touchmove', onIconMouseMove, true);
                        (<any>window).removeEventListener('touchmove', windowTouchMove, { passive: false });
                    }
                    var angle = getRotationAngle(cursorOffsetX, cursorOffsetY);
                    var item = new CorrectionItemViewModel();
                    item.correctionType = vm.correctionType;
                    item.locationX = (lineX - parentOffset.left) / getZoom();
                    item.locationY = (lineY - parentOffset.top - verticalMargin) / getZoom();
                    item.rotationAngle = angle;
                    item.height = 15;
                    var width = 0;
                    if (angle % (Math.PI / 2) == 0) {
                        width = Math.round(Math.max(Math.abs(cursorOffsetX), Math.abs(cursorOffsetY)));
                    }
                    else {
                        var side = Math.min(Math.abs(cursorOffsetX), Math.abs(cursorOffsetY));
                        width = Math.round(Math.sqrt(2 * Math.pow(side, 2)));
                    }
                    width = width - extraWidth;
                    item.width = width / getZoom();
                    if (item.width > 3) {
                        pushIcon(item);
                    }
                    if (!resizing) {
                        document.getElementById('canvasContainer').removeChild(line);
                    }                    
                    line = null;
                    lineX = null;
                    lineY = null;
                    verticalMargin = 0;
                    vm.resetDrawingTool();
                }
                resizing = false;

                var headerHeight = $('.md-toolbar-tools').height();
                if (evt.touches) {
                    (<any>window).removeEventListener('touchmove', windowTouchMove, { passive: false });
                }
            }

            function onMarkerMouseDown(e) {
                parentOffset = $('#canvasContainer').offset();
                var evt = e.originalEvent == null ? e : e.originalEvent;
                line = evt.target.parentElement;
                line.parentElement.addEventListener('mousemove', onCanvasMouseMove, true);
                if (evt.touches) {
                    line.parentElement.addEventListener('touchmove', onCanvasMouseMove, true);
                    (<any>window).addEventListener('touchmove', windowTouchMove, { passive: false });
                }
                if (line.className.indexOf('pen') > -1) {
                    //verticalMargin = 7;
                }
                else {
                    extraWidth = 10;
                }
                lineX = parseInt(line.style.left != null ? line.style.left : '0') + parentOffset.left;
                lineY = parseInt(line.style.top != null ? line.style.top : '0') + parentOffset.top;
                resizing = true;
                vm.dragElement = null;
                evt.stopPropagation();
                evt.stopImmediatePropagation();
            }

            if (canEdit) {
                window.addEventListener('mouseup', mouseUp, false);
                window.addEventListener('touchend', mouseUp, false);

                $('body').on('mousedown', '#canvasContainer .correction,#canvasContainer .pen,#canvasContainer .arrow', onIconMouseDown);
                $('body').on('touchstart', '#canvasContainer .correction,#canvasContainer .pen,#canvasContainer .arrow', onIconMouseDown);

                $('body').on('mousedown', '#canvasContainer', onCanvasMouseDown);
                $('body').on('touchstart', '#canvasContainer', onCanvasMouseDown);

                $('body').on('mousedown', '#canvasContainer .marker', onMarkerMouseDown);
                $('body').on('touchstart', '#canvasContainer .marker', onMarkerMouseDown);
            }

            this.unsubscribeEvents = function() {
                window.removeEventListener('mouseup', mouseUp, false);
                window.removeEventListener('touchend', mouseUp, false);
                $('body').off('mousedown', '#canvasContainer .correction,#canvasContainer .pen,#canvasContainer .arrow', onIconMouseDown);
                $('body').off('touchstart', '#canvasContainer .correction,#canvasContainer .pen,#canvasContainer .arrow', onIconMouseDown);
                $('body').off('mousedown', '#canvasContainer .marker', onMarkerMouseDown);
                $('body').off('touchstart', '#canvasContainer .marker', onMarkerMouseDown);
            }
        }

        public getElement(): HTMLCanvasElement {
            return document.getElementById(this.elementId) as HTMLCanvasElement;
        }

        public selectTool(type: CorrectionType) {
            if (type.toString() == CorrectionType[CorrectionType.comment]) {
                if (this.correctionType == type) {
                    this.$timeout(() => this.correctionType = null);
                }
                else {
                    $('#canvasViewport').scrollTop(0);
                    $('#canvasViewport').scrollLeft(0);
                    this.$timeout(() => this.correctionType = type);

                    setTimeout(() => $('.comment-list').height($('#canvasViewport').height() - $('.comment-block').height()), 100);
                }
            }
            else {
                $('#canvasContainer').css('cursor', 'crosshair');
                this.$timeout(() => this.correctionType = type);
            }
            
        }

        public resetDrawingTool() {
            $('#canvasContainer').css('cursor', 'default');
            this.$timeout(() => this.correctionType = null);
        }
    }
}